import { Grid, Stack, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FormField, useFormStore } from '@tom-ui/utils'
import { FormProps } from '@yard/app/models/form-props.model'
import { observer } from 'mobx-react-lite'
import {
  SBB_MAX_WIDTH,
  SBB_MIN_WIDTH,
  validateSpaceBetweenBaysWidth,
} from '../../helpers/space-between-bays-validation.utils'
import { ISpaceBetweenBaysConfigAreaFormData } from '../../models/yard-setup.model'

interface Props extends FormProps {
  onSubmit: (formValues: ISpaceBetweenBaysConfigAreaFormData) => Promise<void> | void
}

export const SpaceBetweenBaysConfigAreaForm = observer((props: Props) => {
  const { id, onSubmit } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const formStore = useFormStore<ISpaceBetweenBaysConfigAreaFormData>()

  const handleSubmit = () => {
    if (formStore.validate()) {
      onSubmit(formStore.data)
    }
  }

  return (
    <Grid
      id={id}
      component='form'
      autoComplete='off'
      noValidate
      container
      onSubmit={event => {
        event.preventDefault()
        handleSubmit()
      }}
      spacing={theme.customSpacing.m}
    >
      <Grid size={12}>
        <FormField
          formStore={formStore}
          name={'widthInMeters'}
          initialValue={''}
          validate={value => {
            const error = validateSpaceBetweenBaysWidth(value as string | number | undefined)
            if (error === 'required') return t('fieldIsRequired', 'Field is required')
            if (error === 'belowMin')
              return t('spaceBetweenBaysWidthBelowMin', 'Width must be at least {min}m', {
                min: SBB_MIN_WIDTH,
              })
            if (error === 'aboveMax')
              return t('spaceBetweenBaysWidthAboveMax', 'Width must not exceed {max}m', {
                max: SBB_MAX_WIDTH,
              })
          }}
        >
          {store => (
            <Stack>
              <TextField
                {...store.props}
                autoFocus
                fullWidth
                label={t('spaceBetweenBaysWidth', 'Width (m)')}
                required
                name='widthInMeters'
                type='number'
                inputProps={{ step: 0.1, min: SBB_MIN_WIDTH, max: SBB_MAX_WIDTH }}
                error={!!store.error}
                helperText={store.error}
              />
            </Stack>
          )}
        </FormField>
      </Grid>
    </Grid>
  )
})
